import { FC } from "react";
import { UpdateSubRecipeDetailsRawProductsResponse } from "../../../services/subrecipe/subrecipe.types";
import SubRecipeRawProductUpdatesTable from "./SubRecipeRawProductUpdatesTable";
import Button from "../../../components/Button/Button";
import { Buttons } from "../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles";
import { Variant } from "../../../components/Button/Button.types";
import Export from "../../../components/Export/Export";
import { Row } from "./ChangeRawProducts.styles";

interface ReviewProps {
  updates: UpdateSubRecipeDetailsRawProductsResponse[]
  reset: () => void
}

const Review: FC<ReviewProps> = (
    {
      updates,
      reset
    }
) => {
  const exportData = updates.map(
      (update) => {
        return {
          specNo: update.spec.specNo,
          specDescription: update.spec.description,
          subSpec: update.subSpec,
          oldRawProductNo: update.oldRawProduct.moaRawProdNo,
          oldRawProductDesc: update.oldRawProduct.moaRawProdDesc,
          oldUsageAmount: update.oldUsageAmount,
          newRawProductNo: update.newRawProduct.moaRawProdNo,
          newRawProductDesc: update.newRawProduct.moaRawProdDesc,
          newUsageAmount: update.newUsageAmount,
        }
      })
  return (
      <>
        <Row>
          <SubRecipeRawProductUpdatesTable
              updates={updates}
          />
          <Buttons>
            <Export
                rowData={exportData}
                columnHeaders={[
                  { field: 'specNo', headerName: 'Spec' },
                  { field: 'specDescription', headerName: 'Spec Description' },
                  { field: 'subSpec', headerName: 'Sub Spec' },
                  { field: 'oldRawProductNo', headerName: 'Old Raw Product' },
                  { field: 'oldRawProductDesc', headerName: 'Old Raw Product Description' },
                  { field: 'oldUsageAmount', headerName: 'Old Usage Amount' },
                  { field: 'newRawProductNo', headerName: 'New Raw Product' },
                  { field: 'newRawProductDesc', headerName: 'New Raw Product Description' },
                  { field: 'newUsageAmount', headerName: 'New Usage Amount' },
                ]}
            />
            <Button
                label={'Continue'}
                variant={Variant.Secondary}
                onClick={reset}
            />
          </Buttons>
        </Row>
      </>
  )
}

export default Review;